module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    class: _vm.className,
    attrs: {
      "id": _vm.className || 'redactor'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dd85308"}!./src/app/components/redactor/redactor.html
// module id = 1421
// module chunks = 0